export function getConnectionType() {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const effectiveType = (window as any).navigator?.connection?.effectiveType

    if (typeof effectiveType === 'string') {
      return effectiveType
    }
  } catch {
    return 'unknown'
  }
}
